<div class="main-container">
    <div class="search-box-container">
        <app-search-box [width]="'100%'"></app-search-box>
    </div>
    <app-list-results 
    [loading]="loading" 
    [showMapButton]="false" 
    [results]="results"
    [showMapButton]="false"
    [showMoreButton]="false"></app-list-results>
</div>